import { addToChainAfter } from "@insite/client-framework/HandlerCreator";
import { getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import placeOrder, {
    chain,
    SetPaymentMethod,
} from "@insite/client-framework/Store/Pages/CheckoutReviewAndSubmit/Handlers/PlaceOrder";

export type CustomPlaceOrderParameter = Parameters<typeof placeOrder>[0] & {
    customerPaymentProfileId?: string;
    customerPaymentProfileName?: string;
};

type HandlerType = Parameters<typeof SetPaymentMethod>[0];

function AddCustomerPaymentProfile(props: HandlerType) {
    if (!props.cartToUpdate.paymentMethod) {
        return;
    }

    const settingsCollection = getSettingsCollection(props.getState());
    const storedCreditCardPaymentMethod = settingsCollection?.cartSettings?.storedCreditCardPaymentMethod ?? "";
    if (storedCreditCardPaymentMethod && props.cartToUpdate.paymentMethod?.name === storedCreditCardPaymentMethod) {
        props.cartToUpdate.properties["customerPaymentProfileId"] =
            (props.parameter as CustomPlaceOrderParameter).customerPaymentProfileId ?? "";
    }
}
addToChainAfter(chain, SetPaymentMethod, AddCustomerPaymentProfile);
